module.exports = __webpack_public_path__ + "img/callingcards.43192dc8.svg";